import { Plus, Minus, RotateCcw, MapPin, LocateFixed } from "lucide-react";

const Btn = ({ onClick, children, testId, active, label }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    aria-label={label}
    title={label}
    className={`w-9 h-9 grid place-items-center rounded-lg transition-colors duration-200 ${active ? "bg-emerald-500/20 text-emerald-300" : "text-slate-300 hover:bg-white/10 hover:text-white"}`}
  >
    {children}
  </button>
);

export const MapControls = ({ onIn, onOut, onReset, showCities, onToggleCities, onLocate, locating }) => (
  <div className="absolute bottom-4 right-4 flex gap-1 p-1 rounded-xl glass">
    {onLocate && <Btn onClick={onLocate} testId="map-locate-me" label={locating ? "Hide where I am" : "Show where I am"} active={locating}><LocateFixed size={15} /></Btn>}
    <Btn onClick={onIn} testId="map-zoom-in" label="Zoom in"><Plus size={16} /></Btn>
    <Btn onClick={onOut} testId="map-zoom-out" label="Zoom out"><Minus size={16} /></Btn>
    <Btn onClick={onReset} testId="map-reset" label="Reset view"><RotateCcw size={15} /></Btn>
    <Btn onClick={onToggleCities} testId="map-toggle-cities" label="Toggle cities" active={showCities}><MapPin size={15} /></Btn>
  </div>
);

const Item = ({ cls, label }) => (
  <span className="flex items-center gap-2"><span className={`inline-block ${cls}`} />{label}</span>
);

export const MapLegend = () => (
  <div className="absolute bottom-4 left-4 hidden sm:flex gap-4 px-3 py-2 rounded-xl glass font-mono text-[10px] uppercase tracking-[0.15em] text-slate-300" data-testid="map-legend">
    <Item cls="w-3 h-3 rounded-sm bg-[#0F7048] border border-emerald-500/60" label="Been there" />
    <Item cls="w-3 h-3 rounded-sm bg-[#F59E0B]/60" label="Want to go" />
    <Item cls="w-2.5 h-2.5 rounded-full bg-[#39FF88] shadow-[0_0_8px_#39FF88]" label="City visited" />
    <Item cls="w-2 h-2 rounded-full bg-[#FBBF24]" label="City to visit" />
    <Item cls="w-1.5 h-1.5 rounded-full bg-[#64748B]" label="Not yet" />
  </div>
);
